import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import './style.css';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));



export default function Forms() {

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        <Grid item xs={1} sm={3}></Grid>
        <Grid item xs={10} sm={6}>
          <h4>Após se cadastrar, você receberá por e-mail a sua senha. O seu e-mail será o seu login.</h4>
          <br></br>
          <form id="PS-Cadastro-Estudante-Form">
            <p id="PS-Title-Cadastro-Estudante" >Nome</p>
            <input placeholder="Sua resposta" type="text" id="PS-Cadastro-Estudante-Forms" />
            <p id="PS-Title-Cadastro-Estudante" >CRM</p>
            <input placeholder="Sua resposta" type="text" id="PS-Cadastro-Estudante-Forms" />
            <p id="PS-Title-Cadastro-Estudante" >CPF</p>
            <input placeholder="Sua resposta" type="text" id="PS-Cadastro-Estudante-Forms" />
            <p id="PS-Title-Cadastro-Estudante" >Telefone</p>
            <input placeholder="Sua resposta" type="text" id="PS-Cadastro-Estudante-Forms" />
            <p id="PS-Title-Cadastro-Estudante" >Endereço</p>
            <input placeholder="Sua resposta" type="text" id="PS-Cadastro-Estudante-Forms" />
            <p id="PS-Title-Cadastro-Estudante" >RG</p>
            <input placeholder="Sua resposta" type="text" id="PS-Cadastro-Estudante-Forms" />
            <p type="ratio" id="PS-Title-Cadastro-Estudante">Especialidade</p>
            <select id="PS-Cadastro-Estudante-Forms">
              <option value="1">Opçao 1</option>
              <option value="2">Opção 2</option>
              <option selected value="3">Opção 3</option>
              <option value="4">Opçao 4</option>
            </select>
            <br></br>
            <p id="PS-Title-Cadastro-Estudante">Tipo de Voluntariado</p>
            <select id="PS-Cadastro-Estudante-Forms">
              <option value="1">Disponho-me para atendimento inloco</option>
              <option value="2">Disponho-me para telemonitoração e orientação de demais profissionais e alunos</option>
              <option selected value="3">Estudante de medicina ou enfermagem</option>
              <option value="4">Outra área da saúde</option>
            </select>
            <br></br>
            <Button variant="contained" id="exit-PS-Cadastro-Estudante"  onClick={alert("Funcionalidade ainda não disponível, entre em contato com Organizador!")} >Enviar</Button>
          </form>
        </Grid>
        <Grid item xs={1} sm={3}>
        </Grid>
      </Grid>
    </div>
  );
}
